import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
interface Item {
    id: string;
    name: string;
    land?: string;
    selected?: boolean;
    description?: string;
}

@Component({
    selector: 'clever-selectionbtn',
    templateUrl: './selectionbtn.component.html',
    styleUrls: ['./selectionbtn.component.scss'],
    standalone: false
})
export class SelectionbtnComponent implements OnInit {
    @Input() mode: string;
    @Input() isCheckBox: boolean = false;
    @Input() title: string;
    @Input() isMultiselect: boolean = true;
    @Input() list: Item[];
    @Output() sendRes: EventEmitter<Item[] | Item> = new EventEmitter();
    expanded = true;
    slicenbr: number = 5;
    constructor(
        protected cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
    }

    selectItem(item: Item) {
        item.selected = !item.selected;
        if (!this.isMultiselect) {
            for (let i = 0; i < this.list.length; i++) {
                this.list[i].selected = (this.list[i].id === item.id && item.selected);
            }
            if (item.selected) {
                this.sendRes.emit(item);
            } else {
                this.sendRes.emit(null);
            }
        } else {
            this.sendRes.emit(this.list);
        }
        this.cdr.detectChanges();
    }

    toggleExpand() {
        this.expanded = !this.expanded;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }
}
